import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';
import { Button } from 'react-admin';

const StyledButton = styled(Button)(({ theme }) => ({
    color: theme?.palette?.error?.main || '#d32f2f',
}));

const AttachmentRemoveButton = (props) => {
    const { attachment, onRemove } = props;

    const handleClick = useCallback(() => {
        onRemove(attachment);
    }, [onRemove, attachment]);

    return (
        <StyledButton
            label="Remove attachment"
            onClick={handleClick}
        >
            <DeleteIcon />
        </StyledButton>
    );
};

AttachmentRemoveButton.propTypes = {
    attachment: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default AttachmentRemoveButton;
